import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { userInfoLinkBusinessAccountsCacheKeys } from "./constants";
import type {
  PostUserInfoLinkBusinessAccountsByIdentifierProps,
  UserInfoLinkBusinessAccountsResponse,
} from "./types";

export const postUserInfoLinkBusinessAccountsByIdentifier = reactQueryMutationAdapter(
  userInfoLinkBusinessAccountsCacheKeys,
  ({
    userIdentifier,
    accounts,
  }: PostUserInfoLinkBusinessAccountsByIdentifierProps): Promise<UserInfoLinkBusinessAccountsResponse> => {
    return fetch<UserInfoLinkBusinessAccountsResponse>(
      `/apps/user_info_link_business_accounts/${encodeURIComponent(userIdentifier)}`,
      "POST",
      { accounts },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
